if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocumentListFilters);
} else {
    initDocumentListFilters();
}

function initDocumentListFilters() {

    document.querySelectorAll('.document-list-filter-block').forEach(block => {

        const filter = block.querySelector('.document-list-filter');
        const documentLists = block.querySelectorAll('.document-list');

        filter.addEventListener('change', function () {
            const selectedValue = this.value;

            documentLists.forEach(list => {
                list.style.display =
                    selectedValue === 'all' || list.id === selectedValue
                        ? ''
                        : 'none';
            });
        });

    });
}
